export { default } from './VaultBenefits';
